<template>
  <div>
    <v-sheet :rounded="isSmallerDisplay() ? '' : 'lg'" class="pa-2">
      <v-card-title>{{ $t('message.documents') }}</v-card-title>
      <v-list v-if="pending && pending.length > 0">
        <v-subheader>
          <v-icon size="20" class="mr-1">mdi-file-document-alert-outline</v-icon>
          {{ $t('message.pending') }}</v-subheader>
        <template v-for="(i, index) in pending">
          <v-list-item :key="'pending_document' + index"
            @click="navigateTo({ name: 'viewacademydocumentnotification', params: { academyDocumentId: i._id, notificationId: 'pending' } })">
            <v-list-item-content>
              <v-list-item-title>
                {{ i.name }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="i.managedAcademy && i.managedAcademy.academy">
                <v-avatar v-if="i.managedAcademy.academy.image" class="mr-1" size="15">
                  <ImageDisplay :src="i.managedAcademy.academy.image" />
                </v-avatar>
                {{ i.managedAcademy.academy.name }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="index + 1 < pending.length" :key="index"></v-divider>
        </template>
      </v-list>
      <v-list v-if="waivers && waivers.length > 0">
        <v-subheader>
          <v-icon size="20" class="mr-1">mdi-file-document-check-outline</v-icon>
          {{ $t('message.completed') }}</v-subheader>
        <template v-for="(i, index) in waivers">
          <v-list-item :key="'document' + index"
            @click="navigateTo({ name: 'viewacademydocument', params: { academyDocumentId: i._id } })">
            <v-list-item-content>
              <v-list-item-title>
                {{ i.name }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="i.time">{{ $d(new Date(i.time), 'month_day_year', $i18n.locale) }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="i.academy">
                <v-avatar v-if="i.image" class="mr-1" size="15">
                  <ImageDisplay :src="i.image" />
                </v-avatar>
                {{ i.academy }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="index + 1 < waivers.length" :key="index"></v-divider>
        </template>
      </v-list>
    </v-sheet>
    <v-skeleton-loader v-if="loading" type="list-item, list-item, list-item"></v-skeleton-loader>
  </div>
</template>
<script>
import ConnectService from "@/services/ConnectService";
import AcademyDocumentService from "@/services/AcademyDocumentService";

export default {
  data() {
    return {
      waivers: [],
      pending: [],
      loading: true,
    };
  },
  components: {
  },
  created() {
    this.getWaivers();
    this.getPendingDocuments();
  },
  methods: {
    getPendingDocuments() {
      this.loading = true;
      AcademyDocumentService.pendingDocuments(this.selectedFamilyMember)
        .then(response => {
          this.pending = response.documents;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getWaivers() {
      ConnectService.waivers()
        .then((data) => {
          if (data) {
            this.waivers = data.waivers;
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err)
          if (err)
            this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
